































































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseCUModalComponent from '@/mixins/BaseCUModalComponent';
import { AxiosResponse } from 'axios';
import Survey from '@/intefaces/Survey';

const flatPicker = require('vue-flatpickr-component');
import 'flatpickr/dist/flatpickr.css';
import UserLazydropdown from '@/components/lazyDropdown/UserLazydropdown.vue';
import QuestionLazyDropdown from '@/components/lazyDropdown/QuestionLazyDropdown.vue'
import { Timespan } from "@/enums/Timespan";
import { Switch, Tag } from "element-ui";
import ChannelLazydropdown from "@/components/lazyDropdown/ChannelLazydropdown.vue";
import DepartmentCategoryLazyDropdown from "@/components/lazyDropdown/DepartmentCategoryLazyDropdown.vue";
import DepartmentLocationTypeLazyDropdown from "@/components/lazyDropdown/DepartmentLocationTypeLazyDropdown.vue";
import TerritoryCascaderDropdown from "@/components/resources-autocomplete/TerritoryCascaderDropdown.vue";
import BadgeLazydropdown from "@/components/lazyDropdown/BadgeLazydropdown.vue";
import LazyDropdown from "@/components/LazyDropdown.vue";
import moment from "moment";

@Component({
  components: {
    LazyDropdown,
    BadgeLazydropdown,
    TerritoryCascaderDropdown,
    DepartmentLocationTypeLazyDropdown,
    DepartmentCategoryLazyDropdown,
    ChannelLazydropdown,
    UserLazydropdown, flatPicker, QuestionLazyDropdown, [Tag.name]: Tag, [Switch.name]: Switch,
  }
})
export default class CreateSurveyForm extends Mixins(BaseCUModalComponent) {
  @Prop()
  currentEntity!: Survey;
  @Prop({
    default: () => ({
      name: '',
      expires_at: null,
      code: '',
      timespan: null,
      times: 0,
      start_from: null,
      for: [],
      active: true,
      is_default: true,
    })
  })

  form!: {
    name: string;
    expires_at: string;
    code: string;
    timespan: string;
    times: number;
    start_form: string;
    for: string;
    active: boolean;
    is_default: boolean;
  };
  private territories: any[] = [];
  private badges: any[] = [];
  private departmentTypes: any[] = [];
  private departmentCategories: any[] = [];
  private departmentLocationTypes: any[] = [];
  private users: any[] = [];
  private questions: any[] = [];
  private surveyTypes = [
    'consumer',
    'outlet',
  ]

  formReset(): any {
    this.form.name = '';
    this.form.expires_at = '';
    this.form.code = '';
    this.form.timespan = '';
    this.form.times = 0;
    this.form.start_form = '';
    this.form.for = '';
    this.users = [];
    this.questions = [];
    this.territories = [];
    this.badges = [];
    this.departmentTypes = [];
    this.departmentCategories = [];
    this.departmentLocationTypes = [];
    return this.form;
  }

  get disableSaveBtn():boolean{
    return (!this.territories || this.territories.length === 0) && !this.isUpdate;
  }
  get getConfigStartDate(): any {
    return {
      allowInput: true,
      minDate: moment().add(1, 'day').format('YYYY-MM-DD'),
    };
  }

  get getConfigEndDate(): any {
    let self: any = this;
    const start_date = self.form.start_form ? new Date(self.form.start_form) : null;

    return {
      allowInput: true,
      minDate: start_date ? moment(start_date).format('YYYY-MM-DD') : null,
      disable: [
        function (date: Date) {
          return start_date && moment(start_date).diff(date) > 0;
        }
      ]
    };
  }

  async afterCreate(response: AxiosResponse<any>): Promise<void> {
    if (this.users.length > 0) {
      await this.assignUsers(response.data.survey);
    }

    if (this.questions.length > 0) {
      await this.assignQuestion(response.data.survey)
    }

    if (this.territories.length > 0) {
      await this.assignTerritories(response.data.survey)
    }

    if (this.badges.length > 0) {
      await this.assignBadges(response.data.survey)
    }

    if (this.departmentTypes.length > 0) {
      await this.assignDepartmentTypes(response.data.survey)
    }

    if (this.departmentCategories.length > 0) {
      await this.assignDepartmentCategories(response.data.survey)
    }

    if (this.departmentLocationTypes.length > 0) {
      await this.assignDepartmentLocationTypes(response.data.survey)
    }

    this.$emit('created', response.data.survey);
  }

  afterUpdate(response: AxiosResponse<any>): void {
    this.$emit('updated', response.data.survey);
  }

  get createApi(): string {
    return '/surveys';
  }

  get updateApi(): string {
    return `/surveys/${this.currentEntity.id}`;
  }

  get timespan() {
    return Timespan;
  }

  async assignUsers(survey: Survey) {
    for (const value of this.users) {
      await this.$http.post(this.$api(`/surveys/${survey.id}/assignees`), {user_id: value});
    }
  }

  async assignQuestion(survey: Survey) {
    for (const value of this.questions) {
      await this.$http.post(this.$api(`/surveys/${survey.id}/questions`), {question_id: value});
    }
  }

  async assignTerritories(survey: Survey) {
    for (const value of this.territories) {
      await this.$http.post(this.$api(`/surveys/${survey.id}/territories`), {territory_id: value});
    }
  }

  async assignBadges(survey: Survey) {
    for (const value of this.badges) {
      await this.$http.post(this.$api(`/surveys/${survey.id}/badges`), {badge_id: value});
    }
  }

  async assignDepartmentTypes(survey: Survey) {
    for (const value of this.departmentTypes) {
      await this.$http.post(this.$api(`/surveys/${survey.id}/department-types`), {department_type_id: value});
    }
  }

  async assignDepartmentCategories(survey: Survey) {
    for (const value of this.departmentCategories) {
      await this.$http.post(this.$api(`/surveys/${survey.id}/department-categories`), {department_category_id: value});
    }
  }

  async assignDepartmentLocationTypes(survey: Survey) {
    for (const value of this.departmentLocationTypes) {
      await this.$http.post(this.$api(`/surveys/${survey.id}/department-location-types`), {department_location_type_id: value});
    }
  }

}
